import { defineMessages } from 'react-intl';
import { WORKSHOP_SERVICES_NAMES } from '../names/_workshopServices.names';

const intlPrefix =
  'app.dealer.account.DealerProfileSettings.ServicesPanel.services.intl.workshopServices';

/**
 * @typedef {import('../names/_workshopServices.names').WORKSHOP_SERVICES_NAMES} WorkshopServicesNames
 * @typedef {Record<WorkshopServicesNames, {id: string, defaultMessage: string}>} WorkshopServicesNamesIntl
 */

/**
 * `defineMessages` is used by `react-intl`. It is just a function that returns the object it's passed.
 * `react-intl` needs it to comply with babel-plugin-react-intl and i18n message extraction.
 *
 * @description
 * workshop services intl text
 *
 * @const workshopServicesIntl
 * @type {WorkshopServicesNamesIntl}
 */
export const workshopServicesIntl = defineMessages({
  [WORKSHOP_SERVICES_NAMES.EMISSIONS_TEST]: {
    id: `${intlPrefix}.emissionsTest`,
    defaultMessage: 'Abgasuntersuchung',
  },
  [WORKSHOP_SERVICES_NAMES.AXLE_ALIGNMENT]: {
    id: `${intlPrefix}.axleAlignment`,
    defaultMessage: 'Achsenvermessung',
  },
  [WORKSHOP_SERVICES_NAMES.EXHAUST_SOOT_PARTICLE_FILTER]: {
    id: `${intlPrefix}.exhaustSootParticleFilter`,
    defaultMessage: 'Auspuff / Rußpartikelfilter',
  },
  [WORKSHOP_SERVICES_NAMES.BRAKE_CHECK_AND_REPAIR]: {
    id: `${intlPrefix}.brakeCheckAndRepair`,
    defaultMessage: 'Bremsenüberprüfung & -reparatur',
  },
  [WORKSHOP_SERVICES_NAMES.ELECTRICS_ELECTRONICS_SERVICE]: {
    id: `${intlPrefix}.electricsElectronicsService`,
    defaultMessage: 'Elektrik / Elektronik-Service',
  },
  [WORKSHOP_SERVICES_NAMES.CHASSIS_AND_SHOCK_ABSORBER_CHECK_AND_REPAIR]: {
    id: `${intlPrefix}.chassisAndShockAbsorberCheckAndRepair`,
    defaultMessage: 'Fahrwerk- & Stoßdämperüberprüfung & -reparatur',
  },
  [WORKSHOP_SERVICES_NAMES.TRANSMISSION_CHECK_AND_REPAIR]: {
    id: `${intlPrefix}.transmissionCheckAndRepair`,
    defaultMessage: 'Getriebecheck & -reparatur',
  },
  [WORKSHOP_SERVICES_NAMES.HU_AU]: {
    id: `${intlPrefix}.huAu`,
    defaultMessage: 'HU + AU',
  },
  [WORKSHOP_SERVICES_NAMES.INSPECTIONS_AND_CHECK_UPS]: {
    id: `${intlPrefix}.inspectionsAndCheckups`,
    defaultMessage: 'Inspektionen & Check-Ups',
  },
  [WORKSHOP_SERVICES_NAMES.AIR_CONDITIONING_SERVICE]: {
    id: `${intlPrefix}.airConditioningService`,
    defaultMessage: 'Klima-Service',
  },
  [WORKSHOP_SERVICES_NAMES.CAR_BODY_SERVICE]: {
    id: `${intlPrefix}.carBodyService`,
    defaultMessage: 'Karosserie-Service',
  },
  [WORKSHOP_SERVICES_NAMES.MOPED_REPAIR]: {
    id: `${intlPrefix}.mopedRepair`,
    defaultMessage: 'Mofa (Reparatur)',
  },
  [WORKSHOP_SERVICES_NAMES.MOTORCYCLE_REPAIR]: {
    id: `${intlPrefix}.motorcycleRepair`,
    defaultMessage: 'Motorrad (Reparatur)',
  },
  [WORKSHOP_SERVICES_NAMES.OIL_CHANGE]: {
    id: `${intlPrefix}.oilChange`,
    defaultMessage: 'Ölwechsel',
  },
  [WORKSHOP_SERVICES_NAMES.WHEELS_REPAIR]: {
    id: `${intlPrefix}.wheelsRepair`,
    defaultMessage: 'Räder (Reparatur)',
  },
  [WORKSHOP_SERVICES_NAMES.TIRES_REPAIR]: {
    id: `${intlPrefix}.tiresRepair`,
    defaultMessage: 'Reifen (Reparatur)',
  },
  [WORKSHOP_SERVICES_NAMES.WINDSCREEN_REPAIR_AND_REPLACEMENT]: {
    id: `${intlPrefix}.windscreenRepairAndReplacement`,
    defaultMessage: 'Scheibenreparatur & -austausch',
  },
  [WORKSHOP_SERVICES_NAMES.AUXILIARY_HEATING_SERVICE]: {
    id: `${intlPrefix}.auxiliaryHeatingService`,
    defaultMessage: 'Standheizungsservice',
  },
  [WORKSHOP_SERVICES_NAMES.TUNING]: {
    id: `${intlPrefix}.tuning`,
    defaultMessage: 'Tuning',
  },
  [WORKSHOP_SERVICES_NAMES.ACCIDENT_REPORT]: {
    id: `${intlPrefix}.accidentReport`,
    defaultMessage: 'Unfallgutachten',
  },
  [WORKSHOP_SERVICES_NAMES.ACCIDENT_REPAIR]: {
    id: `${intlPrefix}.accidentRepair`,
    defaultMessage: 'Unfallinstandsetzung',
  },
  [WORKSHOP_SERVICES_NAMES.AUTHORIZED_WORKSHOP]: {
    id: `${intlPrefix}.authorizedWorkshop`,
    defaultMessage: 'Vertragswerkstatt',
  },
});
